import { type Action, combineReducers, configureStore, type ThunkAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './auth/auth.reducer';
import filtersReducer from './filters/filters.reducer';
import { authApi } from '@/services/authApi';
import { eventsApi } from '@/services/eventsApi';
import { fileLibraryApi } from '@/services/fileLibraryApi';
import { locationsApi } from '@/services/locationsApi';
import { notificationsApi } from '@/services/notificationsApi';
import { palmettoGroupApi } from '@/services/palmettoGroupApi';
import { registrationApi } from '@/services/registrationApi';
import { settingsApi } from '@/services/settingsApi';

const NODE_ENV = import.meta.env.MODE;

const rootReducer = combineReducers({
  auth: authReducer,
  filters: filtersReducer,
  // RTK Query reducers
  [authApi.reducerPath]: authApi.reducer,
  [eventsApi.reducerPath]: eventsApi.reducer,
  [fileLibraryApi.reducerPath]: fileLibraryApi.reducer,
  [locationsApi.reducerPath]: locationsApi.reducer,
  [notificationsApi.reducerPath]: notificationsApi.reducer,
  [palmettoGroupApi.reducerPath]: palmettoGroupApi.reducer,
  [registrationApi.reducerPath]: registrationApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      eventsApi.middleware,
      fileLibraryApi.middleware,
      locationsApi.middleware,
      notificationsApi.middleware,
      palmettoGroupApi.middleware,
      registrationApi.middleware,
      settingsApi.middleware
    ),
});

setupListeners(store.dispatch);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action>;
